module.exports = __webpack_public_path__ + "img/03.547dd0f9.png";